import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { Button, Card, CardGroup, Col, Container, Row } from "react-bootstrap";
import { NoPictureIcon } from "../../../data/iconImage";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { filteredItemByArray } from "../../../utils/ManageArray";
import { getServiceRequest } from "../../../commons/ServiceRequest";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../../../components/FormComponent";
import SearchFilter from "../../../components/SearchFilter";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import EmployeesService from "../../../services/employee.service";

export default function EmployeeInformation() {
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(null);
  const searchInput = [
    {
      name: "Employee_Code",
      label: "รหัสพนักงาน",
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: EmployeesService.getAllEmployees(query),
          callback: ({ items }) => setData(items)
        })
    },
    {
      name: "Employee_Name",
      label: "ชื่อ-นามสกุล พนักงาน",
      queryService: (query) =>
        getServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: EmployeesService.getAllEmployees(query),
          callback: ({ items }) => setData(items)
        })
    }
  ];
  const inputField = [
    { name: "Employee_Code", label: "รหัสพนักงาน", type: "text" },
    { name: "Employee_Active", label: "สถานะ", type: "select" },
    { name: "Employee_Name", label: "ชื่อ", type: "text" },
    { name: "Employee_Surname", label: "นามสกุล", type: "text" },
    { name: "Employee_Sex", label: "เพศ", type: "text" },
    { name: "Employee_Position", label: "ตำแหน่ง", type: "text" },
    { name: "Employee_Department", label: "แผนก", type: "text" },
    { name: "Employee_Part", label: "หน้าที่", type: "text" },
    { name: "Com_Code", label: "บริษัท", type: "text", size: 12 },
    { name: "Employee_Phone", label: "เบอร์โทร", type: "phone" },
    { name: "Employee_Mobile", label: "เบอร์มือถือ", type: "phone" },
    { name: "Employee_Fax", label: "เบอร์แฟกซ์", type: "phone" },
    { name: "Employee_Email", label: "อีเมล", type: "text" }
  ];

  return (
    <>
      <Helmet>
        <title>ข้อมูลพนักงาน</title>
        <meta name="description" content="Employee Information Page" />
      </Helmet>

      <Container fluid className="p-3">
        <CardDisplayComponent
          body={{
            element: (
              <SearchFilter
                data={data}
                inputField={searchInput}
                fieldClassName={{ actionButton: "w-auto py-2" }}
                searchCallback={(search) =>
                  setFilteredData(
                    search.some(({ value }) => value)
                      ? filteredItemByArray(data, search)[0]
                      : null
                  )
                }
              />
            )
          }}
        />

        <CardDisplayComponent
          body={{
            as: Row,
            className: "pe-lg-5",
            element: (
              <>
                <Col lg={6} sm={12}>
                  <Card.Header className="mb-4 pt-0 px-0 bg-transparent">
                    <Card.Title className="fs-2">ข้อมูลผู้ใช้งาน</Card.Title>
                  </Card.Header>

                  <Card.Body as={Row} className="p-0">
                    {inputField.map(({ name, label, type, size }, idx) => {
                      const value =
                        filteredData && name === "Employee_Sex"
                          ? filteredData?.[name] === "M"
                            ? "ชาย"
                            : "หญิง"
                          : filteredData?.[name];

                      return (
                        <Col
                          key={idx}
                          sm={size || 6}
                          className={`mt-1 ${
                            ![11, 12].includes(idx) ? "mb-3" : ""
                          } fs-4`}
                        >
                          {type === "select" ? (
                            <SearchSelectComponent
                              disabled
                              labelField={label}
                              floatingClass="mb-3"
                              placeholder="โปรดเลือก"
                              options={[
                                { value: true, label: "ใช้งาน" },
                                { value: false, label: "ไม่ใช้งาน" }
                              ]}
                              value={value}
                            />
                          ) : (
                            <FloatingControlComponent
                              readOnly
                              type={type}
                              name={name}
                              label={label}
                              value={value || "-"}
                            />
                          )}
                        </Col>
                      );
                    })}
                  </Card.Body>

                  <Card.Footer className="mt-3 px-0 bg-transparent border-top-0">
                    <Button
                      variant="success"
                      className="px-5 pt-2 text-dark rounded-pill"
                    >
                      อัพโหลดข้อมูล
                    </Button>
                  </Card.Footer>
                </Col>

                <Col lg={6} sm={12} className="ps-lg-5 d-flex flex-column">
                  <Card.Header className="mb-4 pt-0 px-0 bg-transparent border-bottom-0">
                    <Card.Title className="fs-2 text-center">
                      รูปพนักงาน
                    </Card.Title>
                  </Card.Header>

                  <Card.Body className="ms-lg-1 pt-0 pb-5 px-lg-5 flex-grow-1">
                    <Row className="h-100 flex-column justify-content-center align-items-center border border-secondary rounded-4">
                      <Card.Img
                        className={
                          filteredData?.Employee_Pic ? "w-100" : "w-10"
                        }
                        src={
                          filteredData?.Employee_Pic
                            ? `${process.env.REACT_APP_STORAGE_URL}/technician-picture/${filteredData?.Employee_Pic}`
                            : NoPictureIcon
                        }
                        alt={filteredData?.Employee_Pic || "No Picture Icon"}
                      />

                      {!filteredData?.Employee_Pic && (
                        <Card.Text className="mt-3 fs-4 text-center text-secondary">
                          ไม่มีรูปภาพ
                        </Card.Text>
                      )}
                    </Row>
                  </Card.Body>
                </Col>
              </>
            )
          }}
        />
      </Container>
    </>
  );
}
